import { apiFetch } from '@/lib/api';
import type {
  EventAgenda,
  UpsertAgendaInput,
} from '@/routes/tools/research-proposal/components/WizardSteps/Step4Proposal/AgendaManager/constants';

export type { EventAgenda, UpsertAgendaInput };

async function parseResponse<T>(res: Response, errorMsg: string): Promise<T> {
  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    const error = new Error(errorData.error?.message || errorData.message || errorMsg);
    (error as any).status = res.status;
    (error as any).response = errorData;
    throw error;
  }
  const json = await res.json();
  return json.data ?? json;
}

/**
 * Service for the proposal "Prelim Agenda".
 */
export class AgendaService {
  /** Get the agenda for an event (persisted, or a seeded default shell). */
  async getAgenda(eventId: string): Promise<EventAgenda> {
    const res = await apiFetch(`/api/agenda/${eventId}`);
    const data = await parseResponse<{ agenda: EventAgenda }>(res, 'Failed to load agenda');
    return data.agenda;
  }

  /** Create or update the agenda for an event. */
  async saveAgenda(eventId: string, input: UpsertAgendaInput): Promise<EventAgenda> {
    const res = await apiFetch(`/api/agenda/${eventId}`, {
      method: 'PUT',
      body: JSON.stringify(input),
    });
    const data = await parseResponse<{ agenda: EventAgenda }>(res, 'Failed to save agenda');
    return data.agenda;
  }
}

export const agendaService = new AgendaService();
